export const ptBR = {
	translation: {
		//PÁGINA DE LOGIN
		//header
		'login-header': 'Bem-vindo!',
		//login CTA
		'login-cta': 'Faça o login para acessar nossa plataforma!',
		//login question
		'login-question': 'Ainda não possui acesso a nossa plataforma?',
		//login plans CTA
		'login-plans-cta': 'Clique no botão abaixo para ver nossos planos:',
		//login button
		'login-button-plans': 'VER PLANOS',
		//login e-mail field
		'login-email': 'e-mail',
		//login e-mail password
		'login-password': 'senha',
		//login button access
		'login-button-access': 'ENTRAR',
		//login button forgot password
		'login-button-forgot-password': 'Esqueceu sua senha?',

		//HEADER DE GRUPOS
		//group-welcome
		'group-welcome': 'Bem-vindo',
		//group-intro
		'group-intro': 'Você está logado como',
		//group-admin
		'group-admin': 'Administrador!',
		//group-user
		'group-user': 'Usuário!',
		//group-header
		'group-header': 'GRUPOS',
		//group-button
		'group-button': 'NOVO GRUPO',

		//GRUPOS LISTA
		//group-list-header
		'group-list-header': 'Visualizar Grupos',
		//group-list-title
		'group-list-intro': 'PROJETOS',
		//group-list-button
		'group-list-button': 'NOVO PROJETO',
		//group-searchbar
		'group-searchbar': 'Pesquise aqui...',
		//group-no-projects
		'group-no-projects': 'Esse grupo não possui nenhum projeto vinculado! 😢',
		'group-duplicate': 'Deseja duplicar esse grupo?',
		'group-duplicate-description': 'Essa ação irá copiar o grupo e seus respectivos projetos.',

		//GRUPOS ITENS DA TABELA
		//group-table-title
		'group-table-title': 'TÍTULO',
		//group-table-description
		'group-table-description': 'DESCRIÇÃO',
		//group-table-manager
		'group-table-manager': 'RESPONSÁVEL',
		//group-table-actions
		'group-table-actions': 'AÇÕES',
		//group-table-action-download
		'group-table-action-download': 'Download CSV',
		//group-table-action-duplicate
		'group-table-action-duplicate': 'Duplicar',
		//group-table-action-edit
		'group-table-action-edit': 'Editar',
		//group-table-action-delete
		'group-table-action-delete': 'Deletar',
		//group-table-action-answers
		'group-table-action-answers': 'Registros',
		//group-table-action-access
		'group-table-action-access': 'Acessar',
		//group-table-icon
		'group-table-icon': 'ÍCONE',
		//group-table-action-icon
		'group-table-action-icon': 'Alterar ícone',
		//project-icon-modal-title
		'project-icon-modal-title': 'Ícone do projeto: {{projectName}}',
		//project-icon-modal-description
		'project-icon-modal-description':
			'Selecione um ícone para exibir na listagem de projetos no app mobile.',
		//project-icon-modal-save
		'project-icon-modal-save': 'Salvar ícone',
		//project-icon-toast
		'project-icon-toast': 'Ícone do projeto atualizado com sucesso!',

		//DOWNLOAD CSV MODAL
		'initial-date': 'Data Início',
		'final-date': 'Data Final',
		'generate-excel': 'Gerar',

		//GRUPOS PÁGINA
		//group-char-min
		'group-char-min': 'O valor deve conter no mínimo 4 caracteres.',
		//group-char-max
		'group-char-max': 'O valor deve conter no máximo 20 caracteres.',
		//group-char-required
		'group-char-required':
			'Por favor, preencher o campo corretamente. O campo deve ter entre 4-20 caracteres.',
		//group-page-view
		'group-page-view': 'Visualizar Grupos',
		//group-page-header
		'group-page-header': 'GRUPO',
		//group-page-title
		'group-page-title': 'TÍTULO',
		//group-page-manager
		'group-page-manager': 'RESPONSÁVEL',
		//group-page-button
		'group-page-button': 'SALVAR', //criar??
		//group-page-edit
		'group-page-edit': 'EDITAR GRUPO',
		//group-page-edit-title
		'group-page-edit-title': 'Título',
		//group-page-edit-manager
		'group-page-edit-manager': 'Responsável',

		//PÁGINA DE PROJETOS
		//projects-page-view
		'projects-page-view': 'VER PROJETOS',
		//projects-page-header
		'projects-page-header': 'PROJETO',
		//projects-page-edit
		'projects-page-edit': 'EDITAR PROJETO',

		//PROJECTS EDIT PAGE
		//projects-edit-title
		'projects-edit-title': 'Título',
		//projects-edit-description
		'projects-edit-description': 'Descrição',
		//projects-edit-manager
		'projects-edit-manager': 'Responsável',
		'project-edit-toast': 'Projeto editado com sucesso!',

		//ITENS DA TABELA DE PROJETOS
		//projects-table-title
		'projects-table-title': 'Título',
		//projects-table-description
		'projects-table-description': 'Descrição',
		//projects-table-placeholder
		'projects-table-placeholder': 'ex: Projeto de estudos',
		//projects-table-status
		'projects-table-status': 'STATUS',
		//projects-table-active
		'projects-table-active': 'Ativo',
		//projects-table-manager
		'projects-table-manager': 'Responsável',
		//projects-table-owner-email
		'projects-table-email-placeholder': 'ex: seue-mail@email.com',
		//projects-table-save
		'projects-table-save': 'SALVAR',
		'project-duplicate': 'Deseja duplicar esse projeto',
		'project-duplicate-description': 'Essa ação irá duplicar o projeto e seus campos relacionados.',
		'project-duplicate-destination-title': 'Para qual grupo deseja duplicar esse projeto?',

		//PÁGINA DE FORMULÁRIOS DE PROJETOS
		//projects-forms-warning
		'projects-forms-warning': 'Esse projeto não possui nenhum registro. 😢',
		//projects-forms-text
		'projects-forms-text': 'TEXTO',
		//projects-forms-label
		'projects-forms-label': 'LABEL',
		//projects-forms-number
		'projects-forms-number': 'NUMÉRICO',
		//projects-forms-dropdown
		'projects-forms-dropdown': 'DROPDOWN',
		//projects-forms-checkbox
		'projects-forms-checkbox': 'CHECKBOX',
		//projects-forms-radio
		'projects-forms-radio': 'RADIO',
		//projects-forms-counter
		'projects-forms-counter': 'CONTADOR',
		//projects-forms-date
		'projects-forms-date': 'DATA/HORA',
		//projects-forms-image
		'projects-forms-image': 'FOTO/IMAGEM',
		'projects-forms-coordinates': 'COORDENADAS',
		'projects-forms-rating': 'AVALIAÇÃO',
		'projects-forms-rating-variant': 'Variante',
		'projects-forms-rating-variant-zero_to_five': '0 a 5',
		'projects-forms-rating-variant-zero_to_ten': '0 a 10',
		'projects-forms-rating-variant-star': 'Estrelas',
		//projects-forms-sort-button
		'projects-forms-sort-button': 'ORDENAR CAMPOS',
		//projects-forms-records-button
		'projects-forms-records-button': 'REGISTROS',
		//projects-forms-records-title
		'projects-forms-records-title': 'Título',
		//projects-forms-records-description
		'projects-forms-records-description': 'Descrição',
		//projects-forms-records-type
		'projects-forms-records-type': 'Tipo',
		//projects-forms-records-manager
		'projects-forms-records-manager': 'Responsável',
		//projects-forms-records-order
		'projects-forms-records-order': 'Ordem',
		//projects-forms-records-actions
		'projects-forms-records-actions': 'Ações',

		//PROJECT-RECORDS-TABLE
		//project-records-saved
		'project-records-saved': 'REGISTROS',
		//project-records-responsible
		'project-records-responsible': 'Responsável',
		//project-records-latitude
		'project-records-latitude': 'Latitude',
		//project-records-longitude
		'project-records-longitude': 'Longitude',
		//project-records-date
		'project-records-date': 'Data/Hora',
		//project-records-actions
		'project-records-actions': 'Ações',
		//project-records-answers
		'project-records-answers': 'Respostas',
		//project-records-error
		'project-records-error': 'Esse projeto não possui nenhum registro salvo! 😢',
		//project-records-answers-title
		'project-records-answers-title': 'RESPOSTAS',
		'project-records-generate-pdf': 'Gerar Relatório de Pendência (PDF)',
		'project-records-no-pendencies': 'Sem pendências para gerar relatório',

		//GENERAL-ERRORS
		//invalid-email
		'invalid-email': 'E-mail inválido!',
		//empty-field
		'empty-field': 'Por favor, preencha o campo!',
		//forgot-password-warning
		'forgot-password-warning': 'Por favor, entre em contato com seu supervisor!',
		//wrong-email-password
		'wrong-email-password': 'E-mail e/ou senha incorretos!',

		//GENERAL-INFOS
		//options-field-requisition
		'options-field-requisition': 'Por favor, preencha o campo com pelo menos uma opção.',
		//options-field-empty
		'options-field-empty': 'Por favor, insira um valor no campo de Opções.',
		//insert-value-placeholder
		'insert-value-placeholder': 'Insira um valor',
		//write-text-placeholder
		'write-text-placeholder': 'Escreva o texto aqui...',
		//title-placeholder
		'title-placeholder': 'ex: Título',
		//button-project-field-name
		'button-project-field-name': 'Nome do Campo',
		//button-project-field-description
		'button-project-field-description': 'Descrição',
		//button-project-field-manager
		'button-project-field-manager': 'Responsável',
		//button-project-field-options
		'button-project-field-options': 'Opções',
		//obligatory-field
		'obligatory-field': 'Campo obrigatório',
		//go-back-button
		'go-back-button': 'Voltar',
		//loading-warning
		loading: 'Carregando...',
		//delete-option-project
		'delete-option-contract': 'Quer mesmo excluir',
		//delete-verification-contract
		'delete-verification-contract': 'Ao confirmar, o grupo será deletado.',
		//delete-option-project
		'delete-option-project': 'Quer mesmo excluir',
		//delete-verification-project
		'delete-verification-project': 'Ao confirmar, o projeto será deletado.',
		//delete-option-field
		'delete-option-field': 'Quer mesmo excluir o Campo?',
		//delete-verification-field
		'delete-verification-field': 'Ao confirmar, o campo "{{fieldRowTitle}}" será deletado.',
		//delete-option-field-option
		'delete-option-field-option': 'Quer mesmo excluir a Opção do Campo?',
		//delete-verification-field-option
		'delete-verification-field-option':
			'Ao confirmar, a opção "{{fieldOptionIdToDeleteTitle}}" será deletada.',
		//field-delete-button
		'field-delete-button': 'DELETAR',
		//field-cancel-button
		'field-cancel-button': 'CANCELAR',
		//image-button-return
		'image-button-return': 'VOLTAR',
		//image-button-next
		'image-button-next': 'PRÓXIMO',
		//drag-and-drop-alert
		'drag-and-drop-alert': 'Por favor, selecione um arquivo CSV.',
		//drag-and-drop-selected
		'drag-and-drop-selected': 'Arquivo selecionado! 🚀',
		//drag-and-drop-manual
		'drag-and-drop-manual':
			'Arraste e solte um arquivo CSV ou clique para selecionar um manualmente.',
		//new-field-title-header
		'new-field-title': 'NOVO CAMPO',
		//new-field-dropdown-header
		'new-field-dropdown': 'NOVO DROPDOWN',
		//new-field-checkbox-header
		'new-field-checkbox': 'NOVO CHECKBOX',
		//new-field-radio-header
		'new-field-radio': 'NOVO RADIO',
		//new-field-counter-header
		'new-field-counter': 'NOVO CONTADOR',
		//new-field-image-header
		'new-field-image': 'NOVA IMAGEM',
		//sort-fields-button
		'sort-fields-button': 'ORDENAR CAMPOS',
		//sidebar-group-button
		'sidebar-group-button': 'Grupos',
		'sidebar-group-access': 'Controle de Acesso',
		'sidebar-manage-users': 'Gestão de Usuários',

		//HEADERS-NEW-FIELDS
		//new-field-title
		'new-field-header': 'NOVO CAMPO',
		//new-checkbox-header
		'new-checkbox-header': 'NOVO CHECKBOX',
		//new-radio-header
		'new-radio-header': 'NOVO RADIO',
		//new-dropdown-header
		'new-dropdown-header': 'NOVO DROPDOWN',
		//new-counter-header
		'new-counter-header': 'NOVO CONTADOR',
		//new-image-header
		'new-image-header': 'NOVA IMAGEM',

		//FIELDS-TEXTS
		//field-name
		'field-name': 'Nome do Campo',
		//field-name-placeholder
		'field-name-placeholder': 'ex: Título',
		//field-description
		'field-description': 'Descrição do Campo',
		//field-description-placeholder
		'field-description-placeholder': 'ex: Escreva o texto...',
		//field-manager
		'field-manager': 'Responsável',
		//field-option
		'field-option': 'Opção',
		//field-option-placeholder
		'field-option-placeholder': 'Insira um valor',
		//field-option-duplicate
		'field-option-duplicate': 'Esta opção já foi adicionada.',
		//field-update-button
		'field-update-button': 'ATUALIZAR',
		//field-csv-error
		'field-csv-error': 'ERRO AO CARREGAR CSV',
		//csv-limit-field-options
		'csv-limit-field-options': 'Quantidade de opções de campo excedida - MAX: 50 campos',

		//PROJECT-FIELDS
		//project-fields-title
		'project-fields-title': 'Título',
		//project-fields-description
		'project-fields-description': 'Descrição',
		//project-fields-type
		'project-fields-type': 'Tipo',
		//project-fields-manager
		'project-fields-manager': 'Responsável',
		//project-fields-order
		'project-fields-order': 'Ordem',
		//project-fields-actions
		'project-fields-actions': 'Ações',

		//PROJECT-FIELDS-IDS
		//project-fields-id-title
		'project-fields-id-checkbox': 'Checkbox',
		//project-fields-id-text
		'project-fields-id-text': 'Texto',
		//project-fields-id-dropdown
		'project-fields-id-dropdown': 'Dropdown',
		//project-fields-id-radio
		'project-fields-id-radio': 'Radio',
		//project-fields-id-image
		'project-fields-id-image': 'Imagem',
		//project-fields-id-counter
		'project-fields-id-counter': 'Contador',
		//project-fields-id-date
		'project-fields-id-date': 'Data/Hora',
		//project-fields-id-edit
		'project-fields-id-edit': 'Editar',
		//project-fields-id-delete
		'project-fields-id-delete': 'Deletar',
		//project-fields-warning
		'project-fields-warning': 'Esse projeto não possui nenhum campo. 😢',

		//CounterFieldSchema
		//counter-field-max
		'counter-field-max': 'O valor deve conter no máximo 100 caracteres.',
		//counter-field-min
		'counter-field-min': 'O valor deve conter no mínimo 4 caracteres.',
		//counter-field-required
		'counter-field-required':
			'Por favor, preencher o campo corretamente. O campo deve ter entre 4-100 caracteres.',

		// Only Admin
		'admin-only': 'Área exclusiva para administradores!',

		//Dashboard
		'create-chart-modal-title': 'Criar Gráfico',
		'remove-chart-modal-title': 'Remover Gráfico',
		'remove-chart-modal-subtitle': 'Deseja remover o gráfico selecionado?',
		'dashboard-select-values-instruction':
			'Para continuar, por favor selecione o grupo e o projeto.',
		'select-group': 'Selecione o grupo',
		'select-project': 'Selecione o projeto',
		'select-field': 'Selecione o campo',
		'user-log-analysis': 'Análise de Registros por Usuário',
		'check-answers': 'Ver respostas',
		'view-image': 'Visualizar',
		'filter-by-owner-id': 'Filtrar por Usuário',
		'want-remove-the-filter': 'Deseja remover o filtro?',
		'no-map-records': 'Sem registros encontrados no filtro!',
		'asc-filter': 'Ascendente',
		'desc-filter': 'Descendente',
		'ordering-filter': 'Ordenação',
		'general-chart-option': 'Gráfico Geral',
		'group-data-chart-option': 'Relacionar Dados',
		'group-data-chart-remove': 'Remover',
		'group-data-chart-add-relation': 'Adicionar',
		'select-field-option': 'Selecionar opção',
		'related-by': 'Agrupar por:',
		'filters-applied': 'Filtros aplicados:',

		// Grid Locale
		'grid-locale-page': 'Página',
		'grid-locale-more': 'Mais',
		'grid-locale-to': 'para',
		'grid-locale-of': 'de',
		'grid-locale-next': 'Próximo',
		'grid-locale-last': 'Último',
		'grid-locale-first': 'Primeiro',
		'grid-locale-previous': 'Anterior',
		'grid-locale-filterOoo': 'Filtrar...',
		'grid-locale-equals': 'Igual a',
		'grid-locale-notEqual': 'Diferente de',
		'grid-locale-lessThan': 'Menor que',
		'grid-locale-greaterThan': 'Maior que',
		'grid-locale-lessThanOrEqual': 'Menor ou igual a',
		'grid-locale-greaterThanOrEqual': 'Maior ou igual a',
		'grid-locale-inRange': 'Entre',
		'grid-locale-contains': 'Contém',
		'grid-locale-notContains': 'Não contém',
		'grid-locale-startsWith': 'Começa com',
		'grid-locale-endsWith': 'Termina com',
		'grid-locale-dateFormatOoo': 'dd/mm/yyyy',
		'grid-locale-numberFilterOoo': 'Filtrar por número...',
		'grid-locale-textFilterOoo': 'Filtrar por texto...',
		'grid-locale-applyFilter': 'Aplicar filtro',
		'grid-locale-clearFilter': 'Limpar filtro',
		'grid-locale-loadingOoo': 'Carregando...',
		'grid-locale-noRowsToShow': 'Nenhum registro encontrado',
		'grid-locale-selectAll': 'Selecionar tudo',
		'grid-locale-searchOoo': 'Buscar...',
		'grid-locale-blanks': 'Vazios',
		'grid-locale-group': 'Grupo',
		'grid-locale-columns': 'Colunas',
		'grid-locale-filters': 'Filtros',
		'grid-locale-rowGroupColumnsEmptyMessage': 'Arraste colunas aqui para agrupar',
		'grid-locale-valueColumnsEmptyMessage': 'Arraste colunas aqui para agregar',
		'grid-locale-pinColumn': 'Fixar coluna',
		'grid-locale-autosizeThiscolumn': 'Autoajustar esta coluna',
		'grid-locale-autosizeAllColumns': 'Autoajustar todas as colunas',
		'grid-locale-resetColumns': 'Redefinir colunas',
		'grid-locale-expandAll': 'Expandir tudo',
		'grid-locale-collapseAll': 'Recolher tudo',

		// Access Control
		'select-user': 'Selecione o usuário',
		'click-select-user': 'Clique abaixo para listar os usuários',
		'not-found-user': 'Usuário não encontrado',
		'org-without-groups': 'Organização sem grupos criados!',
		'org-without-projects': 'Grupo sem projetos criados!',

		// Generic Error
		'generic-error': 'Ocorreu um erro...',

		// Manage
		'user-created': 'Usuário criado com sucesso!',
		'user-deleted': 'Usuário deletado com sucesso!',
		'user-edited': 'Usuário editado com sucesso!',
		'add-user': 'Adicionar Usuário',
		'col-name': 'Nome',
		'col-email': 'E-mail',
		'col-role': 'Função',
		'col-created-at': 'Criado em',
		'col-actions': 'Ações',
		'row-admin-role': 'Administrador',
		'row-user-role': 'Usuário',
		'insert-value': 'Insira o valor...',
		'modal-password': 'Senha',
		'modal-new-user': 'Novo Usuário',
		'modal-edit-user': 'Editar Usuário',
		'modal-delete-user': 'Deletar Usuário',
		'modal-delete-info': 'Deseja realmente deletar o usuário?',
		'modal-reset-password-info':
			'Caso não deseja alterar a senha do usuário, deixar o campo em branco.',
		'modal-reset-password-label': 'Resetar Senha',
		'modal-reset-password-warning':
			'Ao resetar a senha do usuário a senha padrão estabelecida será "Handler@1234".',
		'validation-name-min': 'O nome deve ter pelo menos 2 caracteres',
		'validation-email-invalid': 'E-mail inválido',
		'validation-password-min': 'A senha deve ter no mínimo 6 caracteres',
		'validation-role-min': 'Selecione uma função válida',

		// Answer Page
		'request-changes': 'Solicitar Alterações',
		'see-pendencies': 'Ver Pendências',
		'pendency-description': 'Descrição da Pendência',
		'record-pendency': 'Pendência do Registro',
		'project-with-no-records': 'Esse projeto não possui registros. 😢',
		'answer-field-not-answered': 'Não respondido',

		// Pendency Card
		'pendency-card-description': 'Descrição',
		'pendency-card-status': 'Status',
		'pendency-card-owner': 'Solicitante',
		'pendency-card-created-at': 'Data de Criação',
		'pendency-card-updated-at': 'Data de Alteração',
		'pendency-resolved': 'Resolvida',
		'pendency-unresolved': 'Não Resolvida',
		'pendency-correction': 'Correção',
		'see-correction': 'Ver correção',
		'edit-pendency': 'Editar pendência',
		'delete-pendency': 'Deletar pendência',
		'delete-confirm-description': 'Ao confirmar, a pendência será deletada.',

		// Correction Page
		'validate-correction': 'Validar Correção',
		'validate-correction-description': 'Ao confirmar, a correção será marcada como resolvida.',
		'correction-created-successfully': 'Solicitação de correção criada com sucesso!',
		'correction-already-exists': 'Já existe uma resposta validada como correção.',

		'attachment-image': 'Anexar Imagem',
		'upload-text': 'Clique ou arraste o arquivo para fazer o upload',
		'upload-hint':
			'Suporte para um único upload. É estritamente proibido o upload de dados da empresa ou outros arquivos proibidos.',

		'pendency-report_file': 'relatorio_pendencia_{{recordId}}.pdf'
	}
};
